interface SuccessStep {
  title: string;
  description: string;
}

interface PublicOfferSuccessStepsProps {
  steps: SuccessStep[];
}

export function PublicOfferSuccessSteps({ steps }: PublicOfferSuccessStepsProps) {
  return (
    <ol className="grid gap-0 sm:grid-cols-3 sm:gap-5">
      {steps.map((step, index) => (
        <li
          key={step.title}
          className="relative min-h-20 pb-5 pl-10 last:min-h-0 last:pb-0 sm:min-h-0 sm:pb-0 sm:pl-0 sm:pt-9"
        >
          <span
            className={`absolute left-0 top-0 z-10 grid size-7 place-items-center rounded-full border bg-background text-2xs font-semibold ${
              index === 0
                ? 'border-status-free/40 bg-status-free/15 text-status-free'
                : 'border-border text-muted-foreground'
            }`}
          >
            {index + 1}
          </span>
          {index < steps.length - 1 ? (
            <span className="absolute bottom-1 left-3.5 top-8 w-px bg-border sm:bottom-auto sm:left-8 sm:-right-2 sm:top-3.5 sm:h-px sm:w-auto" />
          ) : null}
          <p className="text-xs font-semibold text-foreground">{step.title}</p>
          <p className="mt-1 text-2xs leading-5 text-muted-foreground">{step.description}</p>
        </li>
      ))}
    </ol>
  );
}
